import {createRoot} from '@wordpress/element';
import SpacesGrid from './components/SpacesGrid';

window.addEventListener('DOMContentLoaded', (event) => {
    const blockElements = document.getElementsByClassName(`ebo-spaces-grid`);
    for (let blockElement of blockElements) {
        const attributes = JSON.parse(blockElement.dataset.gutenbergAttributes);
        createRoot(blockElement).render(<SpacesGrid attributes={attributes}/>);
    }
});
